<template>
  <div
    v-editable="blok"
    class="w-full"
  >
		<h3 v-if="blok.title" class="text-3xl font-bold mt-20 mb-20 max-w-lg">{{ blok.title }}</h3>
		<div class="grid md:grid-cols-2 gap-x-4 gap-y-10 px-0 w-full">
			<StoryblokComponent
				v-if="blok"
				v-for="blok in blok.list"
				:key="blok._uid"
				:blok="blok"
			/>
		</div>
   
  </div>
</template>
 
<script setup>
defineProps({ blok: Object })
</script>